import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./Social.css";

const Social = () => {
  return (
    <Container style={{ padding: "30px" }}>
      <Row>
        <Col md={12} style={{gap: "15px"}} className="contact-social">
          <div className="contact-text">
            <h1>FIND ME ON</h1>
            <p>
              Please don't hesitate to reach out to me and{" "}
              <span className="yellow">connect.</span>
            </p>
          </div>
          <ul id="contact-github" className="contact-social-links">
            <li className="contact-icons">
              <a
                href="https://github.com/Prabhat-kumar-11"
                target="_blank"
                rel="noreferrer"
                className="icon-color  contact-social-icons"
              >
                <AiFillGithub />
              </a>
            </li>
            <li   id="contact-email" className="contact-icons">
              <a
                href="mailto:prabhssgg3@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="icon-color  contact-social-icons"
              >
                <MdEmail />
              </a>
            </li>
            <li  id="contact-linkedin" className="contact-icons">
              <a
                href="https://www.linkedin.com/in/prabhatkumar511/"
                target="_blank"
                rel="noreferrer"
                className="icon-color  contact-social-icons"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="contact-icons">
              <a
                href="https://www.instagram.com/morningstar11._"
                target="_blank"
                rel="noreferrer"
                className="icon-color contact-social-icons"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Social;
